module.exports = __webpack_public_path__ + "static/share_Erick-57252f3f6d78dfaf1089d7ec168a347a.jpg";